<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
              <el-col :span="3">
                <el-select v-model="pages.store_id" placeholder="全部分店" style="width:100%;" >
                  <el-option
                    key="0"
                    label="全部门店"
                    value="0">
                  </el-option>
                  <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" style="margin-left: 10px">
                <el-input placeholder="请输入订单号" v-model="pages.keyword" class="input-with-select" style="width:100%;">
                </el-input>
              </el-col>

              <el-col :span="3" style="margin-left: 10px">
                <el-date-picker style="width:100%;"
                  v-model="pages.created_start_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="开始时间">
                </el-date-picker>

              </el-col>
              <el-col :span="3" style="margin-left: 10px">
                <el-date-picker style="width:100%;"
                                v-model="pages.created_start_time"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="开始时间">
                </el-date-picker>
              </el-col>

              <el-col :span="6" style="margin-left: 10px">

                <el-button @click="initData">搜索</el-button>
                <el-button type="primary" @click="exportExcel">导出订单</el-button>
              </el-col>
            </el-row>
            <br/>
            <el-table
                :data="orderData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="门店"
                prop="store.name">
              </el-table-column>
              <el-table-column
                label="订单号"
                prop="orderNo">
              </el-table-column>
              <el-table-column
                label="餐桌编号">
                <template slot-scope="scope">
                  <span v-if="scope.row.plan"  style="color: red">预点<br/>用餐时间：{{scope.row.startTime}}</span>
                  <span v-else  style="color: green">{{scope.row.tableNumber}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="支付状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.payStatus == 1" style="color: blue">待支付</span>
                  <span v-else-if="scope.row.payStatus == 2"  style="color: green">已支付</span>
                  <span v-else-if="scope.row.payStatus == 3"  style="color: crimson">部分退款</span>
                  <span v-else-if="scope.row.payStatus == 4"  style="color: red">全部退款</span>
                </template>
              </el-table-column>
              <el-table-column
                label="支付方式"
                prop="payTypeStr">
              </el-table-column>
              <el-table-column
                label="金额(￥)"
                :formatter="realPriceFormat">
              </el-table-column>
              <el-table-column
                label="创建者"
                prop="createdUser.account">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleInfo(scope.row)">
                    详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                baseUrl:window.server.baseUrl,
                loading:false,
                order:{},
                dialog:{
                    dialogFormVisible:false,
                    title:"新增餐桌",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                    store_id:"0",
                    keyword:"",
                    created_start_time:"",
                    created_end_time:"",
                },
              orderData: [],
              stores:[],
            }
        },
        created(){
            this.storesData();
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/main_store/orders', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.orderData = res.data.orders.content;
                    that.pages.total = res.data.orders.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
            storesData(){
              this.loading = true;
              var that = this;
              that.$api.get('/main_store/store', {page:1,pageSize: 10000}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.stores = res.data.stores.content;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            handleInfo(row){
              this.$router.push({path:'/mainStore/orderDetail',query: {order_id: row.id}});
            },

            handlePrinterChange(){
              this.choosePrinterDataModels = null;
            },



            exportExcel(){
              if(this.pages.created_start_time == "" || this.pages.created_end_time == ""){
                this.$message({
                  message: "导出订单请先选择时间区间",
                  type: 'warning'
                });
                return;
              }
              var storage=window.localStorage;
              var accessToken = storage["access_token"];
              location.href=this.baseUrl+"/main_store/orders/excel?access_token="+accessToken+"&keyword="+this.pages.keyword+"&created_start_time="+this.pages.created_start_time+"&created_end_time="+this.pages.created_end_time+"&store_id="+this.pages.store_id;
            },


            realPriceFormat(row,column){
              if((row.realPrice - row.refundPrice)== row.totalPrice){
                return row.realPrice/100+"元";
              }else if(row.refundPrice == 0){
                return "实收:"+row.realPrice/100+"元/总价:"+row.totalPrice/100+"元";
              }else{
                return "实收:"+row.realPrice/100+"元/退款"+row.refundPrice/100+"元/总价:"+row.totalPrice/100+"元";
              }

            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该订单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/mainStore/Orders.vue